import classes from './loader.module.css'
export const Loader = ({ orange }) => {
    return (
        <div className={orange ? classes.orange : classes.loader}></div>
    )
}